import classNames from 'classnames';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { SubmitHandler, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { FormControl } from '../../common/components/form-element';
import { GutterFull } from '../../common/components/layout';
import Layout from '../../common/layout';
import { passwordConfig } from '../config';
import PasswordShowIcon from '../../common/components/icons/show-password-icon';
import { basicError } from '../../common/utils/error';
import { supabase } from '../../lib/supabase';

interface FormValues {
  password: string;
  passwordConfirmation: string;
}

export default function ResetPasswordPage() {
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors: formError },
  } = useForm<FormValues>();

  const onSubmit: SubmitHandler<FormValues> = async (input) => {
    setLoading(true);
    try {
      const { error } = await supabase.auth.updateUser({
        password: input.password,
      });

      if (error) {
        toast.error(error.message);
      } else {
        toast('Password reset successful! You can now login.');
      }
    } catch {
      toast.error(basicError);
    } finally {
      setLoading(false);
    }
  };

  const pageMeta = {
    title: 'Create A Strong Password',
    desc: 'Your password must be more than eight characters and include a combination of numbers, uppercase and lowercase letters and some special characters.',
  };

  return (
    <Layout>
      <GutterFull>
        <Helmet>
          <title>{pageMeta?.title}</title>
        </Helmet>
        <div className="center w-full">
          <div className="w-full">
            <div>
              <div className="mb-3 text-center text-3xl font-extrabold leading-normal">
                {pageMeta?.title}
              </div>
              <div className="mb-3 text-center">{pageMeta?.desc}</div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="grid gap-3 grid-cols-1">
                  <FormControl
                    id="password"
                    type={showPwd ? 'text' : 'password'}
                    formError={formError}
                    formProps={register('password', passwordConfig)}
                    icon={<PasswordShowIcon showPwd={showPwd} setShowPwd={setShowPwd} />}
                  />
                  <FormControl
                    id="passwordConfirmation"
                    label="Password Confirm"
                    type={showPwd ? 'text' : 'password'}
                    formError={formError}
                    icon={<PasswordShowIcon showPwd={showPwd} setShowPwd={setShowPwd} />}
                    formProps={register('passwordConfirmation', {
                      ...passwordConfig,
                      validate: (value) => {
                        return value === getValues('password') || 'password does not match';
                      },
                    })}
                  />
                  <button
                    type="submit"
                    className={classNames([
                      'btn btn-primary',
                      { loading },
                    ])}
                  >
                    Reset password
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </GutterFull>
    </Layout>
  );
}
